<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="店铺名称" prop="shopName">
                <a-input v-model="queryParam.shopName" placeholder="请输入店铺名称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="是否激活过剧本" prop="isActiveScript">
                <a-select v-model="queryParam.isActiveScript" placeholder="请选择是否激活过剧本" allow-clear>
                  <a-select-option :value="1">是</a-select-option>
                  <a-select-option :value="0">否</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="收货省市区" prop="city">
                <a-cascader
                  v-model="selectedCityValue"
                  :options="cityList"
                  change-on-select
                  @change="onCityChange"
                  placeholder="请选择省市区"
                  v-if="cityList"
                />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="免费申领权限范围" prop="freeApplyClaimScope">
                <a-select v-model="queryParam.freeApplyClaimScope" placeholder="请选择免费申领权限范围" allow-clear>
                  <a-select-option :value="1">白名单</a-select-option>
                  <a-select-option :value="2">黑名单</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="元宝" prop="ingot">-->
<!--                <a-input v-model="queryParam.ingot" placeholder="请输入元宝" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <a-col :md="8" :sm="24" style="float: right">
              <span class="table-page-search-submitButtons" :style="{ float: 'right', overflow: 'hidden' }">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
<!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['played:shop:add']">-->
<!--          <a-icon type="plus" />新增-->
<!--        </a-button>-->
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['played:shop:edit']">-->
<!--          <a-icon type="edit" />修改-->
<!--        </a-button>-->
<!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['played:shop:remove']">-->
<!--          <a-icon type="delete" />删除-->
<!--        </a-button>-->
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['played:shop:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="shopId"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <template slot="freeApplyClaimScope" slot-scope="text, record">
          <a-tag v-if="record.freeApplyClaimScope === 1" color="green">白名单</a-tag>
          <a-tag v-if="record.freeApplyClaimScope === 2" color="red">黑名单</a-tag>
        </template>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleIssueCoupons(record.shopId)" v-hasPermi="['played:shop:edit']">
            <a-icon type="edit" />发优惠券
          </a>
          <a-divider type="vertical" v-hasPermi="['played:shop:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['played:shop:edit']">
            <a-icon type="edit" />修改
          </a>
<!--          <a-divider type="vertical" v-hasPermi="['played:shop:remove']" />-->
<!--          <a @click="handleDelete(record)" v-hasPermi="['played:shop:remove']">-->
<!--            <a-icon type="delete" />删除-->
<!--          </a>-->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>

    <a-modal
      ref="issueCouponsRef"
      title="发放优惠券"
      :width="500"
      :visible="issueCouponsModal"
      class="issue-coupon"
      @ok="btnIssueCoupons"
      @cancel="closeModal"
    >
      <a-form-model-item label="优惠券剧本" prop="scriptId">
        <a-button type="dashed" @click="showBindScript" danger v-if="scriptName">
          <span>{{ scriptName }}</span>
        </a-button>
        <a-button type="dashed" @click="showBindScript" danger v-if="!scriptName">
          <span style="color: dodgerblue"> 绑定剧本</span>
        </a-button>
      </a-form-model-item>
      <a-form-model-item label="预购券数量">
        <a-input-number
          v-model="couponsNumber"
          style="width: 100%"
          :min="0"
          :max="99"
          :precision="0"
          placeholder="请输入预购券数量"
        />
      </a-form-model-item>
    </a-modal>
    <index-script-modal
      ref="IndexScriptModal"
      :isPlayedScript="true"
      @select="indexScriptModalSelect"
      @selectName="indexScriptModalName"
    ></index-script-modal>
  </page-header-wrapper>
</template>

<script>
import { listShop, delShop } from '@/api/played/shop'
import { issueShopCoupons } from '@/api/played/shopCoupon'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import { convertToCascaderFormat } from '@/utils/areaDataConverter'
import { Cascader } from 'ant-design-vue'
import IndexScriptModal from '@/components/Script/IndexScriptModal.vue'

export default {
  name: 'Shop',
  components: {
    IndexScriptModal,
    CreateForm,
    'a-cascader': Cascader
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedCityValue: [], // 用于绑定 cascader 的值
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        shopName: undefined,
        isActiveScript: undefined,
        freeApplyClaimScope: undefined,
        // abbreviation: null,
        // ingot: null,
        // haveTestQualifications: null,
        areap: undefined,
        areac: undefined,
        areax: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        // {
        //   title: '店铺id',
        //   dataIndex: 'shopId',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '店铺名称',
          dataIndex: 'shopName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '店铺简称',
          dataIndex: 'abbreviation',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '省',
          dataIndex: 'areap',
          ellipsis: true,
          width: 100,
          align: 'center'
        },
        {
          title: '市',
          dataIndex: 'areac',
          ellipsis: true,
          width: 100,
          align: 'center'
        },
        {
          title: '区',
          dataIndex: 'areax',
          ellipsis: true,
          width: 100,
          align: 'center'
        },
        {
          title: '元宝',
          dataIndex: 'ingot',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '优惠券数量',
          dataIndex: 'couponCount',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '是否含有测本资格',
        //   dataIndex: 'haveTestQualifications',
        //   ellipsis: true,
        //   align: 'center',
        //   customRender: (text) => {
        //     return { 0: '否', 1: '是' }[text]
        //   }
        // },
        {
          title: '是否设置电子围栏',
          dataIndex: 'isSetFence',
          ellipsis: true,
          align: 'center',
          customRender: (text) => {
            return { false: '否', true: '是' }[text]
          }
        },
        {
          title: '电子围栏范围',
          dataIndex: 'geofenceRadius',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '免费申领权限范围',
          dataIndex: 'freeApplyClaimScope',
          scopedSlots: { customRender: 'freeApplyClaimScope' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '10%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ],
      issueCouponsModal: false,
      // 选中的店铺id
      issueShopId: null,
      scriptId: null,
      scriptName: null,
      couponsNumber: 0
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    cityList () {
      const rawData = this.$store.state.user.cityList
      if (rawData && rawData.length > 0) {
        return convertToCascaderFormat(rawData, 3)
      }
      return []
    }
  },
  watch: {
  },
  methods: {
    indexScriptModalSelect(ids) {
      this.scriptId = ids
      console.log('获取到的ids', ids)
    },
    indexScriptModalName(name) {
      this.scriptName = name
      console.log('获取到的剧本名', name)
    },
    showBindScript: function() {
      this.$refs.IndexScriptModal.open()
    },
    /** 查询银河打本商家列表 */
    getList () {
      this.loading = true
      listShop(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.selectedCityValue = []
      this.queryParam = {
        shopName: undefined,
        isActiveScript: undefined,
        // abbreviation: undefined,
        // ingot: undefined,
        // haveTestQualifications: undefined,
        areap: undefined,
        areac: undefined,
        areax: undefined,
        freeApplyClaimScope: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.shopId)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const shopIds = row.shopId || this.ids
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + shopIds + '的数据',
        onOk () {
          return delShop(shopIds)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {}
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('played/shop/export', {
            ...that.queryParam
          }, `shop_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    handleIssueCoupons(shopId) {
      this.issueShopId = shopId
      this.issueCouponsModal = true
    },
    btnIssueCoupons () {
      if (this.couponsNumber == null || this.couponsNumber === 0) {
        this.$message.warning('请输入正确数量进行发放！')
      } else if (this.couponsNumber > 3) {
        const that = this
        this.$confirm({
          title: '确认发放' + this.couponsNumber + '张优惠券?',
          content: '此发放操作不可逆，请再次确认！',
          onOk() {
            const data = {
              shopId: this.issueShopId,
              scriptId: this.scriptId,
              couponsNumber: this.couponsNumber
            }
            issueShopCoupons(data).then(res => {
              this.$message.success(
                '发放优惠券成功',
                3
              )
              that.closeModal()
              that.getList()
            })
          },
          onCancel() {
            that.closeModal()
          }
        })
      } else {
        const data = {
          shopId: this.issueShopId,
          scriptId: this.scriptId,
          couponsNumber: this.couponsNumber
        }
        issueShopCoupons(data).then(res => {
          this.$message.success(
            '发放优惠券成功',
            3
          )
          this.closeModal()
          this.getList()
        })
      }
    },
    // 关闭模态框
    closeModal () {
      this.issueCouponsModal = false
      this.onlyTestCoupon = false
      this.scriptId = null
      this.scriptName = null
      this.couponsNumber = 0
    },
    onCityChange(value) {
      this.queryParam.areap = undefined
      this.queryParam.areac = undefined
      this.queryParam.areax = undefined
      if (value) {
        if (value.length > 0) {
          this.queryParam.areap = value[0]
        }
        if (value.length > 1) {
          this.queryParam.areac = value[1]
        }
        if (value.length > 2) {
          this.queryParam.areax = value[2]
        }
      }
    }
  }
}
</script>
<style scoped>
.issue-coupon .ant-modal-body .ant-form-item {
  margin-bottom: 0;
}
.issue-coupon .ant-modal-body .ant-form-item-label {
  line-height: 18px;
}
</style>
